import { PocTypography } from 'commons/components/components-wrapper/poc-typography.component';
import { ModalDialog } from 'commons/components';
import styled from 'styled-components';

export const AboutBoxModal = styled(ModalDialog)`
    /* OWC-OVERRIDE: the about box has a single footer action, so drop the trailing gap the
       shared modal footer reserves between buttons. owc-button carries the margin on its host
       and exposes no spacing prop in v7.6.0. */
    owc-component-footer[slot='footer'] div[slot='suffix'] .owc-button {
        margin-right: 0;
    }

    .modal-dialog-content owc-button[variant='tertiary'] {
        &:hover,
        &:active {
            background-color: unset !important;
        }

        button {
            padding-left: 0;
        }
    }
`;

export const ContentStyled = styled(PocTypography)`
    color: var(--one-color-foreground-intensity-high);
`;

export const ClickableTextStyled = styled.span`
    color: var(--one-color-interaction-active-brand-base);
    cursor: pointer;
`;

interface StyledContainerProps {
    gap?: string;
}

export const StyledContainer = styled.div<StyledContainerProps>`
    display: flex;
    flex-direction: column;
    gap: ${({ gap }) => gap || '32px'};
`;
